import { createContext, useContext } from 'react';

export const CampaignContext = createContext<any>(null);

export function useCampaign() {
  const campaign = useContext(CampaignContext);
  return campaign;
}
